import httpClient from '../../global/httpClient';
import qs from 'qs';

import * as apis from '../../constants/api';

export const postLogin = (payload) =>
  httpClient.post(apis.LOGIN, qs.stringify(payload), {
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
    },
  });

export const getIMToken = () => httpClient.get(apis.GET_IM_TOKEN);

export const postLoginSms = (payload) =>
  httpClient.post(apis.LOGIN_MOBILE_SMS, qs.stringify(payload), {
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
    },
  });
export const postLoginPasswd = (payload) =>
  httpClient.post(apis.LOGIN_MOBILE_PASSWD, qs.stringify(payload), {
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
    },
  });

export const postSmsRegisterMobilePrecheck = (payload) =>
  httpClient.post(apis.LOGIN_SMS_REGISTER_MOBILE_PRECHECK, qs.stringify(payload), {
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
    },
  });
export const postSmsRegisterWechatPrecheck = (payload) =>
  httpClient.post(apis.LOGIN_SMS_REGISTER_WECHAT_PRECHECK, qs.stringify(payload), {
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
    },
  });
export const postLoginSmsRegisterNewUser = (payload) =>
  httpClient.post(apis.LOGIN_SMS_REGISTER_NEW_USER, qs.stringify(payload), {
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
    },
  });

export const wxLogin = (payload) =>
  httpClient.post(apis.LOGIN_WECHAT, qs.stringify(payload), {
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
    },
  });
export const wxLoginNewUserBind = () => httpClient.post(apis.LOGIN_WECHAT_NEW_USER_BIND);
export const wxLoginOldUserBind = (payload) =>
  httpClient.post(apis.LOGIN_WECHAT_OLD_USER_BIND, qs.stringify(payload), {
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
    },
  });

export const checkLoginQrcode = (payload) =>
  httpClient.get(apis.CHECK_LOGIN_QRCODE + payload.wechatCode, {
    params: { vendorId: payload.vendorId },
    ignore: true,
    ignoreLoading: true,
  });


export const checkCaptcha = (payload) =>{
  return httpClient.post(apis.CHECK_CAPTCHA, { ...payload });
} 